import { useQuery } from "@tanstack/react-query";
import { productKeys } from "../../queryKeys";
import { getProducts } from "../../api/product.api";

export const useFetchProducts = () => {
  return useQuery({
    queryKey: productKeys.all,
    queryFn: getProducts,
    staleTime: 1000 * 60 * 50, // 50 minutes cache
    refetchOnWindowFocus: false,
  });
};